import {
  mergeClasses,
  Skeleton,
  SkeletonItem,
} from "@fluentui/react-components";
import { useStyles } from "./skeletonChat.styles";
import { ISkeletonChatProps } from "./skeletonChat.types";

export const SkeletonChat = (props: ISkeletonChatProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Skeleton className={classes.skeleton} aria-label="Loading Content">
      <div
        className={mergeClasses(
          classes.messageBlock,
          props.avatarOnRight && classes.messageBlockRight,
        )}
      >
        <div className={classes.header}>
          <SkeletonItem shape="circle" animation="wave" size={36} />
          <div className={classes.headerLines}>
            <SkeletonItem
              animation="wave"
              size={12}
              className={classes.headerName}
            />
            <SkeletonItem
              animation="wave"
              size={12}
              className={classes.headerRole}
            />
          </div>
        </div>
        <div className={classes.contentLines}>
          <SkeletonItem
            animation="wave"
            size={12}
            className={classes.contentLineFull}
          />
          <SkeletonItem
            animation="wave"
            size={12}
            className={classes.contentLineMedium}
          />
          <SkeletonItem
            animation="wave"
            size={12}
            className={classes.contentLineShort}
          />
        </div>
        <div className={classes.tagRow}>
          <SkeletonItem
            animation="wave"
            size={12}
            className={classes.tagSmall}
          />
          <SkeletonItem
            animation="wave"
            size={12}
            className={classes.tagMedium}
          />
        </div>
      </div>
    </Skeleton>
  );
};
